import { IPoolMatrixToteResponse } from '@amwager/util-ts';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'matrixData',
  standalone: true,
})
export class MatrixDataPipe implements PipeTransform {

  transform(value: IPoolMatrixToteResponse | null, index: number, type?: 'percent' | 'odd' | 'total'): string | number {
    // console.log('pipe:', value)

    const runnerTotal = value?.Rows[0]?.Columns[index]?.Total;
    const poolTotal = value?.Total;

    return (type === 'percent') && runnerTotal && poolTotal
      ? (runnerTotal/poolTotal*100).toFixed() + "%"
      : (type === 'percent')
        ? '-'
        : (type === 'odd')
          ? value?.Rows[0]?.Columns[index]?.Formatted || '-'
          // total
          : value?.Rows[0]?.Columns[index]?.Total || '0'
  }

}
